import { getCollaborationNotesFile, saveMessageWithFiles } from "@/api/collaboration-notes";
import { getOrderAttachments } from "@/apiv2/orderAttachments";
import { createAction, createSetterActions } from "@/redux/helpers/action";
import { handleError } from "@/redux/utils/error";

import * as selectors from "./attachments.selectors";
import { MODULE } from "./constants";

export const [setAttachments, setSelectedAttachments, setIsFetching] = createSetterActions(MODULE, [
  "attachments",
  "selectedAttachments",
  "isFetching",
]);

export const reset = createAction(`${MODULE}/RESET`);

const getAuthToken = () => JSON.parse(localStorage.getItem("auth"));

const fetchAttachmentsList = async ({ customerUid, orderUid }) => {
  const response = await getOrderAttachments({ customerUid, orderUid })();
  return response?.data ?? [];
};

export const fetchAttachments =
  ({ customerUid, orderUid }) =>
  async (dispatch) => {
    dispatch(setIsFetching(true));
    try {
      const attachments = await fetchAttachmentsList({ customerUid, orderUid });
      dispatch(setAttachments(attachments));
    } catch (error) {
      handleError(error, dispatch);
    } finally {
      dispatch(setIsFetching(false));
    }
  };

export const viewAttachment =
  ({ customerUid, orderUid, fileId }) =>
  async (dispatch) => {
    try {
      const response = await getCollaborationNotesFile(
        customerUid,
        orderUid,
        fileId,
        getAuthToken()
      );
      const fileUrl = window.URL.createObjectURL(
        new File([response.data], fileId, { type: response.data.type })
      );
      window.open(fileUrl);
    } catch (error) {
      handleError(error, dispatch);
    }
  };

export const uploadAttachment =
  ({ customerUid, orderUid, file }) =>
  async (dispatch, getState) => {
    const formData = new FormData();
    formData.set("json", JSON.stringify({ order_id: orderUid, message: "" }));
    formData.append("files", file);

    try {
      const response = await saveMessageWithFiles(getAuthToken(), formData);
      const uploaded = response?.data?.order_chat_message_file?.[0];
      const attachments = await fetchAttachmentsList({ customerUid, orderUid });
      dispatch(setAttachments(attachments));
      // Auto-select the just-uploaded file so the user does not have to tick it themselves.
      // Preserve any prior selections and skip silently if the response shape is unexpected.
      if (uploaded?.id) {
        const currentSelected = selectors.getSelectedAttachments(getState()) ?? [];
        const alreadySelected = currentSelected.some((selected) => selected.id === uploaded.id);
        if (!alreadySelected) {
          dispatch(
            setSelectedAttachments([
              ...currentSelected,
              {
                id: uploaded.id,
                type: uploaded.type,
                fullUrl: uploaded.full_url,
              },
            ])
          );
        }
      }
    } catch (error) {
      handleError(error, dispatch);
    }
  };
